<div class="container mt-5">
    <h1>Etapa</h1>
<form (ngSubmit)="!todoForm.invalid &&saveEtapa()" #todoForm="ngForm">
        
 
    <fieldset class="form-group">
        <label for="nombre">Nombre</label>
        <input type="text" class= "form-control"name ="nombre" required="required"  [(ngModel)]="etapa.nombre">
    </fieldset>



  
    <button class="btn btn-success" type="submit">Guardar</button>
</form>
</div>
